import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { formatValue, humanizeKey } from "./format";

/** Compact table for query results (array rows) or chart data (object rows). */
export function ResultTable({ columns, rows, maxHeight = 320 }) {
	const valueAt = (row, column, index) => (Array.isArray(row) ? row[index] : row[column]);
	const numeric = columns.map((column, index) => rows.some((row) => typeof valueAt(row, column, index) === "number"));
	return (
		<TableContainer sx={{ maxHeight, border: 1, borderColor: "divider", borderRadius: 1 }}>
			<Table size="small" stickyHeader>
				<TableHead>
					<TableRow>
						{columns.map((column, index) => (
							<TableCell key={column} align={numeric[index] ? "right" : "left"} sx={{ fontWeight: 700, whiteSpace: "nowrap", bgcolor: "grey.50" }}>
								{humanizeKey(column)}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row, rowIndex) => (
						<TableRow key={rowIndex} hover>
							{columns.map((column, columnIndex) => {
								const value = valueAt(row, column, columnIndex);
								return (
									<TableCell
										key={column}
										align={typeof value === "number" ? "right" : "left"}
										sx={{ fontVariantNumeric: "tabular-nums", maxWidth: 320 }}
									>
										<Box component="span" sx={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={value === null ? "" : String(value)}>
											{typeof value === "number" ? formatValue(value) : value ?? "—"}
										</Box>
									</TableCell>
								);
							})}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
